import { render, staticRenderFns } from "./changeRemarksModel.vue?vue&type=template&id=01f75b7a&scoped=true&"
import script from "./changeRemarksModel.vue?vue&type=script&lang=js&"
export * from "./changeRemarksModel.vue?vue&type=script&lang=js&"
import style0 from "./changeRemarksModel.vue?vue&type=style&index=0&id=01f75b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f75b7a",
  null
  
)

export default component.exports